import React from "react";
import { Col, Container, Row, Button } from "react-bootstrap";

import Modal from "./bootstrap/modal";

export default function StandardTerms(props) {
  const { onClose } = props;

  return (
    <Modal
      title={"Terms And Conditions"}
      onClose={onClose}
      show
      bodyProps={{style: {padding: 0}}}
      footer={
        <Row>
          <Col xs="auto" className="ml-auto"></Col>
          <Col xs="auto" className="close-modal-col">
            <Button
              className="terms-close"
              onClick={() => onClose()}
            >
              {"Close"}
            </Button>
          </Col>
        </Row>
      }
    >
      <Container fluid className="no-gutters">
        <Row>
          <Col>
            <a target="_blank" href="https://cdn.vostro.cloud/managed-wifi/General-Terms-%26-Conditions.pdf">Click Here for Terms and Conditions</a>
          </Col>
        </Row>
      </Container>
    </Modal>
  );
}
